import { Icon } from "@chakra-ui/react"

const BackArrowIcon = () => {
  return (
    <>
      <Icon
        xmlns='http://www.w3.org/2000/svg'
        width='20px'
        height='22px'
        viewBox='0 0 18 18'
        fill='none'
      >
        <path
          fill='currentColor'
          d='M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
        />
      </Icon>
    </>
  )
}

export default BackArrowIcon
